export const PDFME_VERSION = '6.0.6';
